import React from "react";
import Layout from "../layout";
import { NavLink } from "react-router-dom";
import "./list-produits.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

const ListProduits = () => {
  return (
    <Layout title={"Liste Produits"}>
      <div id="liste_produits">
        <div className="links">
          <NavLink to="/chaines-pl">
            <FontAwesomeIcon icon={faLink} />
            <span>Chaînes PL</span>
          </NavLink>
          <NavLink to="/chaines-vl">
            <FontAwesomeIcon icon={faLink} />
            <span>Chaînes VL TC4</span>
          </NavLink>
          <NavLink to="/chaines-forestieres">
            <FontAwesomeIcon icon={faLink} />
            <span>Chaînes Forestières</span>
          </NavLink>
          <NavLink to="/chaines-deneigement">
            <FontAwesomeIcon icon={faLink} />
            <span>Chaînes de Déneigement</span>
          </NavLink>
        </div>
      </div>
    </Layout>
  );
};

export default ListProduits;
